import { hrmsWithPath } from "../../services/http/api/rest";
import { Meta } from "../../domains/models/document";

const base = hrmsWithPath('/v1');
const rest = hrmsWithPath("/v1/document");

export interface FindDocumentsParams {
    purpose?: string;
    employeeId?: string;
    documentType?: string;
    search?: string;
    eventId?: string;
}

const document = {
    get: (id: string) => rest.get('/{{id}}', {id}),

    list: () => rest.get(
        "/find",
        {},
    ),

    find: (params: FindDocumentsParams, pageNumber?: number, pageSize?: number) => rest.get(
        "/find",
        {},
        {
            "document-purpose": params.purpose,
            "page-number": pageNumber,
            "page-size": pageSize,
            "employee-id": params.employeeId,
            "document-type": params.documentType,
            "search": params.search,
            "event-id": params.eventId,
        }
    ),

    upload: (files: any, docType: string, docNumber?: string, empId?: string, metaInfo?: any, docPurpose?: string) => {
        const formData = new FormData();
        if (files.length > 0) {
            files.forEach((file: any) => {
                formData.append("file", file)
            });

        } else {
            formData.append("file", files)
        }
        if (metaInfo) {
            formData.append("meta-data", JSON.stringify(metaInfo));
        }

        return rest.post(
            "/upload",
            {},
            formData,
            {
                "employee-id": empId,
                "document-type": docType,
                "document-purpose": docPurpose,
                "document-number": docNumber
            },
            {'Content-Type': 'multipart/form-data'}
        );
    },

    download: (id: string) => rest.fetchData('/{{id}}/download', {id}, {}),
    downloadMultiple: (ids: string[]) => rest.post("/bulk-download", {}, ids),
    delete: (id: string) => rest.del('/{{id}}', {id}),
    deleteMultiple: (ids: string[]) => rest.del('', {}, ids),
    changeStatus: (id: string) => rest.put('/{{id}}/updateStatus', {id}),
    fetchMetaData: (type: string) => rest.get('/metadata-definitions', {}, {"document-type": type}),
    updateMetaData:(docId:string,metaValues:Meta[])=>rest.put('/{{docId}}/metadata',{docId},metaValues)
}

export default document;

